const getImageSize = (src) =>
  new Promise((res) => {
    const newImg = new Image();

    const onImgLoad = () => {
      const { height, width } = newImg;
      res({ width, height });
    };

    newImg.addEventListener('load', onImgLoad, { once: true });
    newImg.src = src;
  });

export default getImageSize;
